module.exports = __webpack_public_path__ + "static/media/right-chat-arrow.a131d621.svg";